<!-- Wizard Loading Overlay -->
<app-wizard-loading></app-wizard-loading>

<ng-container *ngIf="loaded && actions && actions[selectedActionIndex]">
  <section class="guide-root">
    <header class="guide-header">
      <div class="guide-header-left">
        <h1 class="guide-title">{{ actions[selectedActionIndex].action_name }}</h1>
        <div class="guide-step">{{ 'StepXOfY' | translate: { current: selectedActionIndex + 1, total: actions.length } }}</div>
      </div>

      <div class="guide-header-right">
        <div class="progress">
          <div
            class="progress-bar"
            role="progressbar"
            [style.width.%]="((selectedActionIndex + 1) / actions.length) * 100"
            [attr.aria-valuemin]="0"
            [attr.aria-valuemax]="100"
            [attr.aria-valuenow]="((selectedActionIndex + 1) / actions.length) * 100"
          ></div>
        </div>

        <div class="steps">
          <button
            type="button"
            class="step-dot"
            *ngFor="let a of actions; let i = index"
            [class.active]="i === selectedActionIndex"
            [class.disabled]="i > selectedActionIndex"
            [disabled]="true"
            [attr.aria-label]="('GoToStep' | translate) + ' ' + (i + 1)"
            [attr.aria-disabled]="true"
          ></button>
        </div>
      </div>
    </header>

    <div *ngIf="canDeferCurrentAction" class="guide-defer">
      <button
        type="button"
        class="defer-link"
        data-testid="guide-defer"
        [disabled]="isDeferringAction"
        (click)="deferCurrentAction()"
      >
        {{ 'ContinueLater' | translate }}
      </button>
    </div>

    <div class="guide-content"
         [class.guide-content-kyc]="actions[selectedActionIndex].action_type === 'KYC'"
         [class.guide-content-questionnaire]="actions[selectedActionIndex].action_type === 'QUESTIONNAIRE'"
         [class.guide-content-signature]="actions[selectedActionIndex].action_type === 'SIGNATURE'">
      <!-- ngFor com slice força destruição/recriação do componente quando currentActionKey muda -->
      <ng-container *ngFor="let action of [actions[selectedActionIndex]]; trackBy: trackByActionKey">
        <ng-container [ngSwitch]="action.action_type">
          <ng-container *ngSwitchCase="'QUESTIONNAIRE'">
            <app-questionnaire-answer
              [claimId]="claimId!"
              [questionnaireId]="action.questionnaire_id!"
              (completed)="onComplete()"
            ></app-questionnaire-answer>
          </ng-container>
          <ng-container *ngSwitchCase="'KYC'">
            <app-kyc
              [action]="action"
              (completed)="onComplete()"
            ></app-kyc>
          </ng-container>
          <ng-container *ngSwitchCase="'SIGNATURE'">
            <app-eletronic-signature-modal
              [contractId]="action.contract_id!"
              [claimId]="action.claim_id!"
              [action]="action"
              [componentView]="true"
              (onComplete)="onComplete()"
            ></app-eletronic-signature-modal>
          </ng-container>
          <ng-container *ngSwitchDefault> </ng-container>
        </ng-container>
      </ng-container>
    </div>
  </section>
</ng-container>
